import React from 'react';

export const ModuleAccess = (module, permission) => {
 
    var modules = {
        'RXM': {
            'SUPADM': ['EXP','ADDATTACHMENT','EDITCLAIM'],
            'GWPFA':['EXP','ADDATTACHMENT','EDITCLAIM'],
            'GWCPA': ['EXP','ADDATTACHMENT','EDITCLAIM'],
            'GWCPU': ['EXP'],
        },
        'DB': {
            'SUPADM': [''],
            'GWCPA': [''],
            'GWCPU': [''],
            'GWPFA':[''],
            'GWTPAU':[''],
        },
        'PO': { 
            'SUPADM': ['ADDPO','EXP','POCLAIMEXP','PODETAILSEXP','POAUTH','POCAN','PODC'],
            'GWTPAU': ['EXP','POCLAIMEXP','PODETAILSEXP'],
            'GWCPA': ['ADDPO','EXP','POCLAIMEXP','PODETAILSEXP'],
            'GWCPU': [''],
            'GWPHA': [''],
            'GWPHU': [''],
            'GWPFA':['ADDPO','EXP','POCLAIMEXP','PODETAILSEXP','POAUTH','POCAN'],
         },
        'INV': {     
            'SUPADM': ['EXP'],
            'GWCPA': ['EXP'],
            'GWCPU': ['EXP'],
            'GWPHA': ['EXP'],
            'GWPFA':['EXP'],
            'GWPHU': ['EXP'],
            'GWTPAU': ['EXP'],
         },
        'CON': {      
            'SUPADM': ['ADD','EXP'],
            'GWPFA':['ADD','EXP'],
            'GWCPA': ['EXP'],
         },
        'REP': {    
            'SUPADM': ['EXP'],
            'GWCPA': ['EXP'],
            'GWCPU': ['EXP'],
            'GWPHA': ['EXP'],
            'GWPFA':['EXP'],
            'GWPHU': ['EXP'],
            'GWTPAU': ['EXP'], 
        },
        'CONFIG': {     
            'SUPADM': ['ChainLevelConfig','EXP'],
            'GWPFA': ['ChainLevelConfig','EXP'],
            'GWCPA': ['ChainLevelConfig','EXP'],
            'GWPHA': ['EXP'],
        },
        'FOR': {      
            'SUPADM': ['EXP'],
            'GWPFA':['EXP'],
            'GWCPA': ['EXP'],
            'GWPHA': [''],
        },
        'INVOICE': {     
           'SUPADM': ['EXP','INVD'],
           'GWPFA':['EXP','INVD'],
           'GWCPA': ['EXP','INVD'],
         },
         'DC':{
            'SUPADM': ['EXP'],
            'GWPFA':['EXP'],
            'GWCPA': ['EXP'],
            'GWTPAU': ['EXP'], 
         }
    };

    const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    let userRoles = [];
    if (access_token) {
        let jwtData = access_token.split('.')[1]
        let decodedJwtJsonData = window.atob(jwtData)
        let decodedJwtData = JSON.parse(decodedJwtJsonData)
        userRoles = decodedJwtData['roles'];
    }

    //console.log(module);
    var roles = modules[module];
    //console.log(roles);
    var permissions = [];
    if (Array.isArray(userRoles)) {
        for (var i = 0; i < userRoles.length; i++) {
            var userRole = userRoles[i];
            //console.log(userRole);
            var userper = roles[userRole];
            //console.log(userper);
            permissions = permissions.concat(userper);
        }
    }
    else {
        var userper = roles[userRoles];
        if (userper)
            permissions = permissions.concat(userper);
    }

    //console.log(permissions);
    if (!permission)
        return permissions.length > 0;
    return permissions.indexOf(permission) != -1;
}